import { TressExceptions } from "@/code/TressExceptions";

export default (maybeTressException: unknown): TressExceptions | undefined => {
  if (typeof maybeTressException === "number") {
    return maybeTressException;
  } else if (typeof maybeTressException === "string") {
    return Number(TressExceptions[maybeTressException]);
  }
  return undefined;
};
